import React from 'react';
import Button from '@mui/material/Button';
import { Link, useLocation } from 'react-router-dom';

const navLinks = ['home', 'about', 'portfolio', 'contact'];

const Nav = () => {
	const { pathname: pathName } = useLocation();
	return (
		<nav>
			<ul className='flex items-center justify-center space-x-1 sm:space-x-3 '>
				{navLinks.map((item, index) => (
					<li key={index}>
						<Button
							to={`/${item}`}
							component={Link}
							variant='text'
							size='small'
							color='inherit'
							// className={`text-xs px-px md:text-lg  lg:text-xl md:py-1 md:px-2  xl:px-3 ${
							className={`text-xs sm:text-base sm:px-3 md:text-lg xl:text-xl xl:px-4 ${
								pathName === `/${item}` ? 'active' : ''
							}`}
						>
							{item}
						</Button>
					</li>
				))}
			</ul>
		</nav>
	);
};

export default Nav;
